import { render, staticRenderFns } from "./RelatedContent.vue?vue&type=template&id=2e51650a"
import script from "./RelatedContent.vue?vue&type=script&lang=js"
export * from "./RelatedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports